"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileRow = exports.RowOptions = exports.Cell = exports.Row = void 0;

var _react = _interopRequireWildcard(require("react"));

var _framerMotion = require("framer-motion");

var _ri = require("react-icons/ri");

var _axios = _interopRequireDefault(require("axios"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Row = function Row(_ref) {
  var children = _ref.children,
      extend = _ref.extend,
      props = _objectWithoutProperties(_ref, ["children", "extend"]);

  return /*#__PURE__*/_react["default"].createElement(_.View, _extends({}, props, {
    extend: [rowCSS, extend]
  }), children);
};

exports.Row = Row;

var Cell = function Cell(_ref2) {
  var children = _ref2.children,
      extend = _ref2.extend,
      props = _objectWithoutProperties(_ref2, ["children", "extend"]);

  return /*#__PURE__*/_react["default"].createElement(_.View, _extends({}, props, {
    extend: [cellCSS, extend]
  }), children);
};

exports.Cell = Cell;

var RowOptions = function RowOptions(_ref3) {
  var refresh = _ref3.refresh,
      deleteUrl = _ref3.deleteUrl,
      onEdit = _ref3.onEdit,
      extend = _ref3.extend;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMore = _useState2[0],
      setShowMore = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDeleting = _useState4[0],
      setIsDeleting = _useState4[1];

  var handleDelete = (0, _react.useCallback)(function () {
    setShowMore(false);
    setIsDeleting(true);

    _axios["default"]["delete"](deleteUrl).then(function () {
      refresh();
    })["catch"](function () {
      setIsDeleting(false);
    });
  }, [deleteUrl, refresh]);
  var handleEdit = (0, _react.useCallback)(function () {
    setShowMore(false);
    onEdit(); // setIsDeleting(true);
    // Axios.delete(`/alert/${alert.id}`)
    //   .then(() => {
    //     refresh();
    //   })
    //   .catch(() => {
    //     setIsDeleting(false);
    //   });
  }, [onEdit]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: [cellCSS, showMoreCSS, extend],
    onClick: function onClick() {
      return setShowMore(!showMore);
    }
  }, showMore ? /*#__PURE__*/_react["default"].createElement(_ri.RiCloseLine, {
    size: 24
  }) : /*#__PURE__*/_react["default"].createElement(_ri.RiMoreLine, {
    size: 24
  })), /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: moreCSS({
      showMore: showMore
    })
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: moreTintCSS,
    as: _framerMotion.motion.div,
    animate: {
      opacity: showMore ? 0.9 : 0
    }
  }), /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: moreOptionsCSS,
    as: _framerMotion.motion.div,
    initial: false,
    animate: {
      scale: showMore ? 1 : 0.5,
      opacity: showMore ? 1 : 0,
      x: showMore ? 0 : 150
    }
  }, onEdit && /*#__PURE__*/_react["default"].createElement(_.Button, {
    variant: "clear",
    onClick: handleEdit
  }, /*#__PURE__*/_react["default"].createElement(_ri.RiBallPenLine, {
    size: 20
  }), /*#__PURE__*/_react["default"].createElement(_.Spacer, null), "Edit"), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    size: 1
  }), /*#__PURE__*/_react["default"].createElement(_.Button, {
    variant: "destructive",
    onClick: handleDelete
  }, /*#__PURE__*/_react["default"].createElement(_ri.RiDeleteBin7Line, {
    size: 20
  }), /*#__PURE__*/_react["default"].createElement(_.Spacer, null), "Delete"))), isDeleting && /*#__PURE__*/_react["default"].createElement(_.LoadingOverlay, null));
};

exports.RowOptions = RowOptions;

var MobileRow = function MobileRow(_ref4) {
  var items = _ref4.items,
      children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: mobileRowCSS
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item, index < items.length - 1 && /*#__PURE__*/_react["default"].createElement(_.Spacer, {
      size: 2
    }));
  }), children);
};

exports.MobileRow = MobileRow;

var mobileRowCSS = function mobileRowCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      breakpoints = _ref5$theme.breakpoints,
      grid = _ref5$theme.grid,
      layout = _ref5$theme.layout;
  return _defineProperty({
    position: 'relative',
    border: "2px solid ".concat(colors.border),
    padding: 2 * grid,
    marginBottom: 2 * grid,
    borderRadius: layout.radius
  }, breakpoints.fromM, {
    display: 'none'
  });
};

var rowCSS = function rowCSS(_ref7) {
  var _ref7$theme = _ref7.theme,
      colors = _ref7$theme.colors,
      layout = _ref7$theme.layout;
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
    borderRadius: layout.radius,
    // "&:hover": {
    //   background: colors.border,
    // },
    '&:hover': {
      // background: colors.border,
      backgroundImage: "linear-gradient(-90deg, ".concat(colors.bg, " 0%, ").concat(colors.border, " 100%)")
    }
  };
};

var cellCSS = function cellCSS(_ref8) {
  var grid = _ref8.theme.grid;
  return {
    position: 'relative',
    margin: 2 * grid,
    // paddingTop: 2 * grid,
    // paddingBottom: 2 * grid,
    flex: 1 // [breakpoints.untilM]: {
    //   ...(hideOnMobile && {
    //     display: "none",
    //   }),
    //   paddingTop: 3 * grid,
    //   paddingBottom: 3 * grid,
    // },

  };
};

var showMoreCSS = function showMoreCSS(_ref9) {
  var _ref9$theme = _ref9.theme,
      colors = _ref9$theme.colors,
      shadows = _ref9$theme.shadows,
      breakpoints = _ref9$theme.breakpoints;
  return _defineProperty({
    // position: "absolute",
    // top: 0,
    // right: 0,
    width: 50,
    flex: 'inherit',
    height: '100%',
    // background: "red",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    // borderBottomLeftRadius: layout.radius,
    // borderTopLeftRadius: layout.radius,
    transition: 'all 150ms ease-in-out',
    zIndex: 3,
    '&:hover': {
      background: colors.border,
      boxShadow: shadows.small
    }
  }, breakpoints.onlyS, {
    // border: "2px dotted orange",
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 0
  });
};

var moreCSS = function moreCSS(_ref11) {
  var showMore = _ref11.showMore;
  return function (_ref12) {
    var grid = _ref12.theme.grid;
    return {
      position: 'absolute',
      top: 0,
      right: 0,
      // background: "hotpink",
      // width: 200,
      // maxWidth: "100%",
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2,
      pointerEvents: showMore ? 'auto' : 'none',
      // background: "red",
      // padding: 2 * grid,
      paddingRight: 7 * grid,
      paddingLeft: 7 * grid
    };
  };
};

var moreTintCSS = function moreTintCSS(_ref13) {
  var colors = _ref13.theme.colors;
  return {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    backgroundColor: colors.border,
    backgroundImage: "linear-gradient(90deg, ".concat(colors.bg, " 0%, ").concat(colors.border, " 100%)"),
    // opacity: 0.9,
    zIndex: 1
  };
};

var moreOptionsCSS = {
  display: 'flex',
  justifyContent: 'center',
  // alignItems: "center",
  zIndex: 2
};